(function() {

    'use strict';

    /**
     * @module Messages
     */

    /**
     * Sent by the GUI when the user activates a button (normally populated by a plugin).
     *
     * @function button_activated
     * @param {String}  messageKind='button_activated'
     * @param {String}  class the button class
     * @param {Boolean} isDisabled
     */

    /**
     * Sent by the GUI when the user changes the player volume explicitly.
     *
     * @function h_volume_change
     * @param {String} messageKind='h_volume_changed'
     * @param {String} direction either 'up' or 'down'
     * @param {Number} value resulting value
     */

    /**
     * Sent by the GUI when the user changes the player size explicitly.
     *
     * @function h_resize
     * @param {String} messageKind='h_resize'
     * @param {String} state either 'normal' or 'full'
     */

    /**
     * Sent by the GUI when the user changes the volume muting state explicitly.
     *
     * @function h_mute
     * @param {String} messageKind='h_mute'
     * @param {String} state either true (mute) or false (unmute)
     */

    /**
     * Sent by the GUI when the user changes the playback state explicitly.
     *
     * @function h_state_changed
     * @param {String} messageKind='h_state_changed'
     * @param {String} state either 'play' or 'pause'
     */

    /**
     * This is subscribed by the GUI to add cues to the time slider where events occur (adwords and rolls)
     *
     * @function add_cue
     * @param {String}  messageKind='add_cue'
     * @param {Object}  cue
     * @param {String}  cue.title  cue title
     * @param {Number}  cue.value  value for the cue, in seconds
     * @param {Number}  cue.width  width of the cue, in pixels
     * @param {String} [cue.color] cue color
     */

    /**
     * This is subscribed by the GUI so a cue can be deleted from the scrubber GUI.
     *
     * @function remove_cue
     * @param {String} messageKind='remove_cue'
     * @param {String} cueId
     */



    /**
     * @module GUI
     *
     *
     * This instance is inaccessible from the outer world.
     * It is fed up to plugins so they can manage buttons in the GUI.
     *
     * @class Main
     */




    var _      = SAPO.Project.Video._,
        Css    = SAPO.Dom.Css,
        Event  = SAPO.Dom.Event,
        Feat   = SAPO.Project.Video.Features,
        Sel    = SAPO.Dom.Selector,
        Slider = SAPO.Project.Video.Components.Slider;

    var moveCb;
    var keyPressed = false;


    var pad00 = function(n) {
        return (n < 10) ? '0' + n : n;
    };

    var formatTime = function(t0) {
        var secs = Math.floor(t0 % 60);
        var mins = Math.floor(t0 / 60);
        var h = Math.floor(mins / 60);
        var arr;
        if (h > 0) {
            mins -= h * 60;
            arr = [h, pad00(mins), pad00(secs)];
        }
        else {
            arr = [mins, pad00(secs)];
        }
        return arr.join(':');
    };



    var Main = function(vc, o, pub, pubD, containerEl) {
        /*jshint maxcomplexity:30, maxstatements:210, scripturl:true */
        this._vc = vc;
        this._pub = pub;
        this._pubD = pubD;
        this._options = o;
        this._buttonEls = {};

        this._handlers = {
            buttonclick:      this._onButtonClick.bindObj(this),
            keydown:          this._onKeyDown.bindObj(this),
            togglefullscreen: this._onToggleFullScreen.bindObj(this),
            toggleplay:       this._onTogglePlay.bindObj(this),
            togglemute:       this._onToggleMute.bindObj(this)
        };

        var that = this;
        var tScrubEl, vScrubEl;

        var el; // parent
        this._els = {};

        this._els.player = containerEl;
        Css.addClassName(this._els.player, Feat.hasTouchEvents ? 'env-mobile' : 'env-desktop');
        Css.addClassName(this._els.player, Feat.isIPhoneOrIPod ? 'iphone-yes' : 'iphone-no');
        Css.addClassName(this._els.player, o.playerInterno ? 'player-internal' : 'player-external');
        Css.addClassName(this._els.player, 'play-paused');
        Css.addClassName(this._els.player, 'no-activity');

        if (o.video) {
            Css.addClassName(this._els.player, 'video-is-new'); // TODO
        }

        Css.addClassName(this._els.player, 'video-mode-regular');
        Css.addClassName(this._els.player, 'at-start');

        var aEl = document.createElement('a'); // ANCHOR
        aEl.className = 'anchor fill';
        this._els.player.appendChild(aEl);
        this._els.aEl = aEl;

        el = document.createElement('div'); // VIDEO-CONTAINER
        el.className = 'video-container fill';
        this._els.aEl.appendChild(el);
        this._els.videoCtn = el;

        if(!vc.getOption('skipShare') && !vc.getOption('playerInterno')) {
            Css.addClassName(this._els.player, 'show-share');
        }

        el = document.createElement('div'); // HUD-BOTTOM
        el.className = 'hud-bottom';
        this._els.player.appendChild(el);
        var hudBottomEl = el;

        if (!vc.getOption('hideInfo')) {
            el = document.createElement('div'); // HUD-TOP
            el.className = 'hud-top';
            this._els.player.appendChild(el);
            var hudTopEl = el;

            el = document.createElement('a'); // TITLE
            el.className = 'title';
            el.setAttribute('target', '_top');
            el.setAttribute('rel', 'title');
            el.title = _('goToSVTitle');
            hudTopEl.appendChild(el);
            this._els.title = el;

            el = document.createElement('a'); // AUTHOR
            el.className = 'author';
            el.setAttribute('target', '_top');
            el.setAttribute('rel', 'author');
            el.title = _('goToSVAuthorTitle');
            hudTopEl.appendChild(el);
            this._els.author = el;
        }


        if (this._options.allowScrub) {
            var elel;
            elel = document.createElement('div');
            elel.className = 't-scrub-height';
            hudBottomEl.appendChild(elel);

            el = document.createElement('div'); // T-SCRUB - SLIDER (VOLUME)
            el.className = 't-scrub';
            elel.appendChild(el);

            tScrubEl = el;

            el = document.createElement('div');
            el.className = 't-cached';
            tScrubEl.appendChild(el);
            this._els.cached = el;

            el = document.createElement('div');
            el.className = 't-done';
            tScrubEl.appendChild(el);

            el = document.createElement('div');
            el.className = 'handle t-handle';
            tScrubEl.appendChild(el);

            el = document.createElement('div');
            el.className = 'tooltip time';
            tScrubEl.appendChild(el);
            this._els.timeTooltip = el;
        }



        el = document.createElement('div');
        el.className = 'buttons';
        hudBottomEl.appendChild(el);
        var buttonsEl = el;

        el = document.createElement('div'); // LEFT
        el.className = 'left';
        buttonsEl.appendChild(el);
        var leftEl = el;
        this._els.left = el;

        if (this._options.allowPlayPause) {
            el = document.createElement('button'); // PLAY-PAUSE
            el.className = 'button b-play';
            el.setAttribute('tabindex', 1100 );

            el.title = _('playPauseTitle');
            leftEl.appendChild(el);
            Event.observe(el, 'click', this._handlers.toggleplay);
            this._els.playPause = el;
        }

        el = document.createElement('span'); // CURRENT-TIME
        el.className = 'current-time';
        //el.innerHTML = '0:00';
        el.title = _('timeTitle');
        leftEl.appendChild(el);
        this._els.currentTime = el;

        el = document.createElement('span'); // DURATION
        el.className = 'duration';
        el.title = _('durationTitle');
        leftEl.appendChild(el);
        this._els.duration = el;


        el = document.createElement('div'); // RIGHT
        el.className = 'right';
        buttonsEl.appendChild(el);
        this._els.right = el;

        if (this._options.allowResize) {
            el = document.createElement('button'); // SIZE-MAXIMIZE
            el.className = 'button size size-maximize';
            el.title = _('resizeFullTitle');
            el.setAttribute('tabindex', 8000);

            this._els.right.appendChild(el);
            Event.observe(el, 'click', this._handlers.togglefullscreen);
            this._els.sizeMaximize = el;
        }


        if (this._options.allowVolume) {
            el = document.createElement('a'); // VOLUME
            el.className = 'button volume volume-3';
            el.href = 'javascript:void(0)';
            el.title = _('muteTitle');
            el.style.zIndex = 3; // NOT FOR IE 7-8
            el.setAttribute('tabindex', 7000);

            this._els.right.appendChild(el);
            Event.observe(el, 'click', this._handlers.togglemute);
            var _this = this;

            Event.observe(el, 'focus', function(){
                Css.addClassName(_this._els.player, 'volume-focused');
            });

            Event.observe(el, 'mouseover', function(){
                Css.addClassName(_this._els.player, 'volume-focused');
            });

            Event.observe(el, 'mouseout', function(){
                Css.removeClassName(_this._els.player, 'volume-focused');
            });

            Event.observe(el, 'blur', function(){
                Css.removeClassName(_this._els.player, 'volume-focused');
            });


            this._els.volume = el;

            el = document.createElement('span');
            el.className = 'v-scrub';
            this._els.volume.appendChild(el);
            vScrubEl = el;

            el = document.createElement('span'); // SLIDER (VOLUME)
            el.className = 'gap';
            vScrubEl.appendChild(el);
            //el.title = _('volumeSliderTitle');
            var gapEl = el;

            el = document.createElement('span');
            el.className = 'v-done';
            gapEl.appendChild(el);

            el = document.createElement('span');
            el.className = 'handle v-handle';
            gapEl.appendChild(el);
        }



        // remove maximize button if in iframe and no FS API
        var inIframe = window.parent.SAPO.Project.Video.Features.inExternalIframe();
        //inIframe = true;

        var FS = window.parent.SAPO.Utility.FullScreen;
        //console.log('fs is supported:', FS.isSupported, ', inIframe:', inIframe);
        if (!FS.isSupported && (inIframe && !Feat.isIPad)) {
            Css.addClassName(this._els.player, 'cannot-resize');
            this._options.allowResize = false;
        }



        if (this._options.allowScrub) {
            this._timeSlider = new Slider({
                 container:      tScrubEl
                ,doneElement:    Sel.select('.t-done',   tScrubEl)[0]
                ,handleElement:  Sel.select('.t-handle', tScrubEl)[0]
                ,tickElement:    this._els.timeTooltip
                ,disableScrubbing: true
                ,value:          0
                ,onStart: function() { // this = slider instance, that = GUI
                    Css.addClassName(that._els.player, 'time-being-dragged');
                    if (that._vc.isPlaying()) {
                        that._vc.pause();
                    }
                }
                ,onChange: function() {
                    that._vc.setCurrentTime(this.getValue(), true);
                    that._vc.play();

                    setTimeout(function() {
                        Css.removeClassName(that._els.player, 'time-being-dragged');
                    }, 150);
                }
                ,onUpdateTick: function(point, ratio) {
                    var dur = that._vc.getDuration();
                    Css.setClassName(this._tickEl, 'hidden', dur === 0 || !isFinite(dur));
                    this._tickEl.innerHTML = formatTime( ratio * dur );
                    var w = this._o.container.offsetWidth;
                    var tw = this._tickEl.offsetWidth; // tick width
                    var minRatio = tw*0.5 / w;
                    if      (ratio < minRatio) {     ratio = minRatio;     }
                    else if (ratio > 1 - minRatio) { ratio = 1 - minRatio; }
                    this._tickEl.style[ this._o.offsetAttr ] = (ratio * 100).toFixed(2) + '%';
                }
            });
        }

        if (this._options.allowVolume) {
            Event.observe(vScrubEl.parentNode, 'mouseover', function() { Css.addClassName(   that._els.player, 'time-slider-hovered'); });
            Event.observe(vScrubEl.parentNode, 'mouseout',  function() { Css.removeClassName(that._els.player, 'time-slider-hovered'); });

            this._volumeSlider = new Slider({
                 container:      Sel.select('.gap',      vScrubEl)[0]
                ,doneElement:    Sel.select('.v-done',   vScrubEl)[0]
                ,handleElement:  Sel.select('.v-handle', vScrubEl)[0]
                ,offsetAttr:     'bottom'
                ,sizeAttr:       'height'
                ,axis:           'y'
                ,value:          1
                ,onStart: function() {
                    this._initialValue = this.getValue();
                }
                ,onChanging: function() {
                    if (!that._repeatingVolume) {
                        that._repeatingVolume = true;
                        //that._lastVolume = that._vc.getVolume();
                    }
                    that._vc.setVolume( this.getValue() );
                }
                ,onChange: function() {
                    that._repeatingVolume = false;
                    var v = this.getValue();
                    var v0 = this._initialValue;
                    var humanChange = (v > v0) ? 'up' : 'down';
                    that._pub('h_volume_changed', humanChange, v);
                    that._vc.setVolume(v);
                }
            });
        }


        if (this._options.allowKeyboard) {
            Event.observe(document.documentElement, 'keydown', this._handlers.keydown);
        }


        // identify events stopping and hide GUI
        var lastActivityTS = 0;
        var hideDt = 2000; // 2s
        var playerEl = this._els.player;

        var onGuiTimer = function() {
            var ts = new Date().valueOf();
            var dt = ts - lastActivityTS;
            if (dt > hideDt) {
                if (!Css.hasClassName(playerEl, 'static')) {
                    guiTimer = undefined;
                    Css.addClassName(playerEl, 'no-activity'); // HIDES GUI
                }
            }
        };
        var guiTimer = setInterval(onGuiTimer, 500);

        moveCb = function(/*ev*/) {
            /*if (ev.type === 'touchend' || ev.type === 'mousedown') {
                window.top.log('MAIN GUI EVENT HANDLER (documentElement) type: ' + ev.type);
            }*/
            lastActivityTS = new Date().valueOf();
            Css.removeClassName(playerEl, 'no-activity'); // MAY SHOW GUI
        };

        if (Feat.hasTouchEvents) {
            Event.observe(document, 'touchend',  moveCb); // not touchstart so vertical swipes for scrolling still work
            Event.observe(document, 'touchmove', moveCb);
        }

        Event.observe(document, 'mousedown', moveCb);
        Event.observe(document, 'mousemove', moveCb);



        this._vc.subscribe('add_cue button_activated ended h_volume_changed h_state_changed load loading_changed loading_data_changed metadata_changed mute progress remove_cue resize state_changed time_updated volume_changed loadedmetadata', undefined, this);
    };

    Main.prototype = {
        on: function(ev, a0) {
            /*jshint maxcomplexity:50 */
            var el;

            var playing = (a0 === 'play');

            switch (ev) {
                case 'add_cue':
                    if (this._timeSlider) {
                        this._timeSlider.addCue(a0);
                    }
                    break;

                case 'button_activated':
                    if (a0 === 'quality') {
                        this._lastQualityChangeT = new Date().valueOf();
                    }
                    break;

                case 'load':
                    //console.log('LOAD video:', a0.requestURL, 'isAd:', a0.isAd, 'isLive:', a0.isLive);

                    this._oldURI = this._currentURI;
                    this._currentURI = a0.requestURL;

                    var wasQualityChange = false;
                    if (this._lastQualityChangeT) { // TODO REVIEW THIS
                        var t = new Date().valueOf();
                        var dt = t - this._lastQualityChangeT;
                        if (dt < 10) {
                            wasQualityChange = true;
                        }
                    }

                    if (this._oldURI !== a0.requestURL && !wasQualityChange) { // TODO REVIEW THIS
                        Css.removeClassName(this._els.player, 'video-is-not-new');
                        Css.addClassName(   this._els.player, 'video-is-new');
                    }

                    var isVPAID = (typeof a0.mimeType === 'string' &&
                        (a0.mimeType === 'text/javascript') || (a0.mimeType === 'application/x-shockwave-flash'));

                    Css.addRemoveClassName(this._els.player, 'vpaid', isVPAID);

                    this._updateTime(0);

                    break;

                case 'ended':
                    Css.removeClassName(this._els.player, 'play-playing');
                    Css.addClassName(this._els.player, 'play-paused');
                    break;

                case 'loading_changed':
                    //console.log(a0 ? 'LOADING' : 'NOT LOADING');
                    Css.setClassName(this._els.player, 'loading', a0);
                    break;

                case 'loading_data_changed':
                    //console.log(a0 ? 'LOADING' : 'NOT LOADING');
                    Css.setClassName(this._els.player, 'loading-data', a0);
                    break;

                case 'metadata_changed':
                    // duration
                    this._isLive = a0.isLive;
                    this._isAd   = a0.isAd;
                    this._dur    = a0.duration;
                    var v;

                    if (this._isLive) {
                        v = _('liveTitle');
                    }
                    else {
                        v = formatTime(a0.duration);
                        if (this._timeSlider) {
                            this._timeSlider.changeLimits(0, a0.duration);
                            this._timeSlider.setScrubbing(!this._isAd); // if is ad, don't allow scrubbing!
                            this._updateTime(0);
                        }
                    }

                    if(!isNaN(a0.duration)) {
                        this._els.duration.innerHTML = v;
                    }

                    Css.removeClassNamesStartingWith(
                        this._els.player,
                        'video-mode-',
                        this._isLive ? 'live' : 'regular'
                    );


                    // title and author
                    var target = this._vc._inInternoMode ? '_top' : '_blank';
                    var noMeta = a0.isAd;
                    this.setTitle( noMeta ? '' : a0.title,  a0.pageURI,   target);
                    this.setAuthor(noMeta ? '' : a0.author, a0.authorURI, target);
                    Css.addRemoveClassName(this._els.player, 'no-metadata', noMeta);
                    break;

                case 'progress':
                    //console.log('start: ' + a0.start.toFixed(2), ', end: ' + a0.end.toFixed(2), ', length: ' + a0.length.toFixed(2));
                    if (this._timeSlider) {
                        var cache = this._vc.getCache(true);
                        if (!cache) { return; }
                        var s = this._els.cached.style;
                        s.left  = (cache.start  * 100).toFixed(3) + '%';
                        s.width = (cache.length * 100).toFixed(3) + '%';
                    }
                    break;

                case 'remove_cue':
                    if (this._timeSlider) {
                        this._timeSlider.removeCue(a0);
                        //this._timeSlider.backupCues(this._currentURI);
                    }
                    break;

                case 'resize':
                    if (this._els.sizeMaximize) {
                        el = this._els.sizeMaximize;
                        el.className = 'button size size-' + (a0.maximized ? 'normal' : 'maximize');
                        el.title = _( 'resize' + (a0.maximized ? '1' : 'Full') + 'Title' );
                    }
                    break;

                case 'h_state_changed':
                
                    Css.setClassName(this._els.player, 'play-paused',  !playing);
                    Css.setClassName(this._els.player, 'play-playing',  playing);
                
                    if (Css.hasClassName(this._els.player, 'at-start')) {
                        return;
                    }

                    // window.top.log('+HINT');
                    Css.addClassName(this._els.player, 'hint');

                    if (this.hint) {
                        clearTimeout(this.hint);
                    }

                    this.hint = setTimeout(
                        function() {
                            // window.top.log('-HINT');
                            Css.removeClassName(this._els.player, 'hint');
                            delete this.hint;
                        }.bindObj(this), 750
                    );
                    break;

                case 'state_changed':
                    if (this._els.playPause) {
                        el = this._els.playPause;

                        Css.setClassName(this._els.player, 'play-paused',  !playing);
                        Css.setClassName(this._els.player, 'play-playing',  playing);

                        if (playing) {
                            Css.removeClassName(this._els.player, 'video-is-new');
                            Css.addClassName(   this._els.player, 'video-is-not-new');
                        }

                        if (Css.hasClassName(this._els.player, 'time-being-dragged')) { return; }
                    }
                    break;

                case 'mute':
                    Css.setClassName(this._els.player, 'muted', a0);
                    if (this._volumeSlider) {
                        //this._volumeSlider.setScrubbing(!a0);

                        el = this._els.volume;
                        el.title = _(a0 ? 'unmuteTitle' : 'muteTitle');
                    }
                    //console.log('mute', a0);
                    break;

                case 'h_volume_changed':
                    if (this._vc.isMuted()) {
                        return this._vc.unmute();
                    }
                    break;


                case 'volume_changed':
                    var suffix;

                    /*if (this._vc.isMuted()) {
                        return this._vc.unmute();
                    }*/

                    if (this._els.volume) {
                        el = this._els.volume;

                        if      (a0 === 0) {   suffix = '0'; }
                        else if (a0 < 0.333) { suffix = '1'; }
                        else if (a0 < 0.666) { suffix = '2'; }
                        else {                 suffix = '3'; }

                        Css.removeClassNamesStartingWith(el, 'volume-', suffix);
                    }
                    if (this._volumeSlider && !this._vc.isMuted()) {
                        this._volumeSlider.setValue(a0);
                    }
                    break;

                case 'time_updated':
                    this._updateTime(a0);
                    break;
            }
        },



        // API for plugins

        /**
         * called by plugins to add new buttons
         *
         * @function addButton
         * @param {String} name
         * @param {String} where (left|right)
         * @return {DOMELement|undefined}
         */
        addButton: function(name, where) {
            var b = this._buttonEls[name];

            if (b) { return; }
            var el = document.createElement('button');
            var keys = SAPO.Utility.objectKeys(this._buttonEls);
            var idx = keys.length || 0;
            el.className = 'button ' + name;

            if (where === 'left') {
                el.setAttribute('tabindex', 1000 + (idx * 200));
                this._els.left.appendChild(el);
            }
            else {
                el.setAttribute('tabindex', 6000 - (idx * 100));
                this._els.right.appendChild(el);
            }

            this._buttonEls[name] = [el, where];

            Event.observe(el, 'click', this._handlers.buttonclick); // ONLY ONE EVENT HANDLER INSTEAD?
            return el;
        },

        /**
         * called by plugins to hide buttons
         *
         * @function hideButton
         * @param {String} name
         * @return {Boolean}
         */
        hideButton: function(name) {
            var b = this._buttonEls[name];
            if (!b) { return; }

            Css.addClassName(b[0], 'hidden');
        },

        /**
         * called by plugins to hide buttons
         *
         * @function showButton
         * @param {String} name
         * @return {Boolean}
         */
        showButton: function(name) {
            var b = this._buttonEls[name];

            if (!b) { return; }

            Css.removeClassName(b[0], 'hidden');
        },

        /**
         * called by plugins to remove buttons
         *
         * @function removeButton
         * @param {String} name
         * @return {Boolean}
         */
        removeButton: function(name) {
            var b = this._buttonEls[name];

            if (!b) { return; }

            var btnEl = b[0];
            var where = b[1];

            ( where === 'left' ? this._els.left : this._els.right ).removeChild(btnEl);

            delete this._buttonEls[name];

            return true;
        },

        /**
         * returns the button associated to a plugin, if available
         *
         * @function getButton
         * @param {String} name
         * @return {ButtonEl|undefined}
         */
        getButton: function(name) {
            var b = this._buttonEls[name];
            if (!b) { return; }
            return b[0];
        },

        /**
         * sets the video title and its link. undefined parameters do no harm
         *
         * @function setTitle
         * @param {String|undefined} title
         * @param {String|undefined} titleURL
         * @param {String|undefined} target
         */
        setTitle: function(title, titleURL, target) {
            this._setLink(this._els.title, title, titleURL, target);
        },

        /**
         * sets the video author and its link. undefined parameters do no harm
         *
         * @function setAuthor
         * @param {String|undefined} author
         * @param {String|undefined} authorURL
         * @param {String|undefined} target
         */
        setAuthor: function(author, authorURL, target) {
            this._setLink(this._els.author, author, authorURL, target);
        },


        _updateTime: function(t, isResuming) {
            var addCls = 'body';

            if (!this._isLive && isFinite(t)) {
                //console.log('update time ', t);
                this._els.currentTime.innerHTML = formatTime(t);
                if (this._timeSlider) {
                    this._timeSlider.setValue(t);
                }

                var dur = this._vc.getDuration();
                //console.log('dur:', dur);
                if (isNaN(dur)) {
                    dur = this._dur;
                }
                var t0 = 0.1;
                var t1 = dur - 0.25;


                if      (t < t0) { addCls = 'start'; }
                else if (t > t1) { addCls = 'end';   }
                else {             addCls = 'body';  }

                if (isResuming) { addCls = 'body'; }
            }

            Css.removeClassNamesStartingWith(
                this._els.player,
                'at-',
                addCls
            );
        },

        _setLink: function(el, label, url, target) {
            if (!el) { return; }

            if (label !== undefined) {
                el.innerHTML = '';
                el.appendChild( document.createTextNode(label) );
            }

            if (url !== undefined) {
                el.setAttribute('href', url);
            }

            if (target !== undefined) {
                el.setAttribute('target', target);
            }
        },

        _onButtonClick: function(ev) {  // TO BE USED BY PLUGINS
            if (Css.hasClassName(this._els.player, 'small')) { Event.stop(ev); }

            var tgtEl = Event.element(ev);
            if (tgtEl.nodeName.toLowerCase() !== 'button') {
                return;
            }
            var classes = tgtEl.className.split(' ');
            var cls;
            for (var i = 0, f = classes.length; i < f; ++i) {
                cls = classes[i];
                this._pub('button_activated', cls);
            }
        },

        _onKeyDown: function(ev) {
            /*jshint maxcomplexity:34 */

            if (!keyPressed) { // first keypress. add class and focus on playPause button
                keyPressed = true;
                Css.addClassName(this._els.player, 'key-pressed');
                if (this._els.playPause) {
                    this._els.playPause.focus();
                }
            }

            moveCb();

            var rr = [82, 73, 67, 75, 82, 79, 76, 76];

            var tgtEl = Event.element(ev);
            var kc = ev.keyCode;
            var nodeName = tgtEl.nodeName.toLowerCase();

            var hasModifiers = ev.altGraphKey || ev.altKey || ev.ctrlKey || ev.metaKey || ev.shiftKey;
            if (hasModifiers) { return; }

            if (nodeName === 'a' && (kc === 13 || kc === 32) && Css.hasClassName(tgtEl, 'volume')) {
                return this._onToggleMute(ev);
            }

            /*if (this._options.allowVolume && (kc === 40 || kc === 38) ) {
                this._lastVolume = this._vc.getVolume();
            }*/

            var vc = this._vc;
            var FS = window.parent.SAPO.Utility.FullScreen;
            var FL = !vc.isHtml5();
            var deltaT = (FL ? 10 : 3);

            switch (kc) {
                case 27: // escape
                    if (this._options.allowResize && this._vc.inFullScreen() && (!FS.isSupported || SAPO.Browser.SAFARI)) {
                        this._onToggleFullScreen();
                    }
                    break;

                case 32: // space
                    if (nodeName === 'button') { return; }
                    this._onTogglePlay();
                    break;

                case 37: // left cursor
                    if (this._options.allowScrub) {
                        vc.scrub(-deltaT);
                    }
                    break;

                case 39: // right cursor
                    if (this._options.allowScrub) {
                        vc.scrub(deltaT);
                    }
                    break;

                case 40: // down cursor
                    if (this._options.allowVolume) {
                        vc.changeVolume(-0.2);
                        this._pub('h_volume_changed', 'down', vc.getVolume());
                    }
                    break;

                case 38: // up cursor
                    if (this._options.allowVolume) {
                        vc.changeVolume(0.2);
                        this._pub('h_volume_changed', 'up', vc.getVolume());
                    }
                    break;

                default: // easter egg
                    if (this._rr && kc === rr[this._rr]) {
                        ++this._rr;
                        if (this._rr === rr.length) {
                            this._vc.load('http://rd3.videos.sapo.pt/gQ6ldkGBvL3mos90bEpB/mov/1', true);
                            delete this._rr;
                        }
                    }
                    else if (kc === rr[0]) {
                        this._rr = 1;
                    }
                    else {
                        return;
                    }
            }
            Event.stop(ev);
        },

        _onToggleFullScreen: function(ev) {
            Event.stop(ev);
            this._vc.toggleFullScreen();
            this._pubD(100, 'h_resize', this._vc.inFullScreen() ? 'full' : 'normal');
        },

        _onToggleMute: function(ev) {
            if (ev) {
                var tgtEl = Event.element(ev);
                if (!Css.hasClassName(tgtEl, 'volume')) { return /*console.log('SKIPPED UI TOGGLE MUTE')*/; } // prevents slider manipulations from toggling the mute button
                Event.stop(ev);
            }

            // console.log('ON TOGGLE MUTE');

            this._vc.toggleMute();
            var isMuted = this._vc.isMuted();
            // console.log('MUTED:', isMuted, ' | VOLUME:', this._vc.getVolume());
            Css.setClassName(this._els.player, 'muted', isMuted);
            this._pub('h_mute', isMuted);
        },

        _onTogglePlay: function(ev) {
            //console.log('MAIN TOGGLE PLAY', ev.type);
            Event.stop(ev);

            if (!this._vc.getCurrentRequestURL()) {
                return;
            }

            // detect replay
            var notNew   = Css.hasClassName(this._els.player,    'video-is-not-new');
            var isPaused = Sel.matchesSelector(this._els.player, '.play-paused, .loading') || !this._vc.isPlaying();
            var atEnd    = Css.hasClassName(this._els.player,    'at-end');

            // effectively toggle
            this._pub('h_state_changed', isPaused ? 'play' : 'pause');

            if (isPaused) {
                // console.log('PLAY!');
                this._vc.play();
            }
            else {
                // console.log('PAUSE!');
                this._vc.pause();
            }

            // detect replay part 2
            if (notNew && atEnd && isPaused) {
                this._pub('replay');
            }
        }
    };



    SAPO.namespace('Project.Video.GUI');

    SAPO.Project.Video.GUI.Main = Main;

})();
